module.exports = __webpack_public_path__ + "img/lookbook_9_center.aa85475b.png";